import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { reactive, onMounted, computed, ref, unref, PropType } from 'vue'
import { useRouter } from 'vue-router'
import dayjs from 'dayjs'
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import { message } from '@dc-platform/dc-components'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import UserSelect from '@/components/UserSelect/index'
import CosRangePicker from '@/components/CosRangePicker/index'
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard'
import { listByParamCodes } from '@/api/common'
import type { ParamCodeItem } from '@/typings/common'
import { downloadFileByBase64 } from '@/utils/index'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import CardLinkModal from './components/CardLinkModal.vue'
import {
  activityList,
  activityEnable,
  activityDisabled,
  activityDelete,
  partnerDropList
} from '@/api/marketing/marketingManage'
import Modal from '@/hooks/modalType'
import { ActivityCodeParams, ActivityCodeListItem } from '@/typings/api/marketingManage'

const __default__ = { name: 'DcCosZbuActivityCode' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  subdomain: {
    type: String as PropType<'fbu' | 'lbu'>,
    required: true
  },
  paramCode: {
    type: String as PropType<string>,
    required: true
  },
  permission: {
    type: Object as PropType<{
      add: string
      edit: string
      delete: string
      enable: string
      disable: string
      qrcode: string
      card: string
    }>,
    default: () => ({}),
    required: true
  }
},
  setup(__props) {

const router = useRouter()
const { clipboardRef, copiedRef } = useCopyToClipboard()

const props = __props

const statusEnum = [
  { name: '启用', value: 1, color: '#3FAC46' },
  { name: '停用', value: 0, color: '#DF443B' }
]
const tableRef = ref()
const queryForm = reactive<ActivityCodeParams>({})

const columns = computed(() => [
  {
    title: '活动名称',
    dataIndex: 'activityName',
    cosType: 'link',
    path: `/${props.subdomain}/activityCode/view`,
    query: ['id'],
    fixed: 'left'
  },
  { title: '来源渠道', dataIndex: 'channelId' },
  { title: '活动时间', dataIndex: ['startTime', 'endTime'], cosType: 'timeRange' },
  { title: '活码获客量', dataIndex: 'salesCount', cosType: 'link', path: `/${props.subdomain}/leadManage`, query: ['channelExplain=$activityName'] },
  { title: '活动负责人', dataIndex: 'followerName' },
  { title: '备注', dataIndex: 'remark' },
  { title: '状态', dataIndex: 'enableFlag' },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', width: 190 },
  { title: '操作', dataIndex: 'action', width: 170, fixed: 'right' }
])
const getList = (queryForm: ActivityCodeParams, callBack: (res: any) => void) => {
  activityList(queryForm).then((res) => {
    callBack(res)
  })
}
const handleTableFetch = () => {
  tableRef.value?.fetch()
}

const paramCodeData = ref<{
  [key: string]: ParamCodeItem[]
}>({
  [props.paramCode]: [] // 来源渠道
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: [props.paramCode]
  }).then((res) => {
    paramCodeData.value = res.data
  })
}
const partnerEnum = ref()
const getPartner = () => {
  partnerDropList().then((res) => {
    partnerEnum.value = res.data
  })
}
onMounted(() => {
  getByParamCodes()
  getPartner()
})

// 关联名片弹窗
const cardLinkModalRef = ref()
const handleCardLink = (rows?: ActivityCodeListItem) => {
  cardLinkModalRef.value?.init(rows)
}

// 新增编辑函数
const triggerAddOrEdit = (id?: number) => {
  if (id) {
    router.push({ path: `/${props.subdomain}/activityCode/edit`, query: { id } })
  } else {
    router.push(`/${props.subdomain}/activityCode/add`)
  }
}
const handleStatus = (row: ActivityCodeListItem) => {
  const params = { activityQrcodeId: row.id }
  if (row.enableFlag) {
    activityDisabled(params).then(() => {
      message.success('活码已停用')
      tableRef.value?.fetch()
    })
  } else {
    const isExpired = dayjs(row.endTime).valueOf() < dayjs().valueOf()
    if (!row.enableFlag && isExpired) return message.warning('活动已过期，无法启用')
    activityEnable(params).then(() => {
      message.success('活码已启用')
      tableRef.value?.fetch()
    })
  }
}
const handleDelete = (row: ActivityCodeListItem) => {
  Modal.delete({
    name: row.activityName,
    onOk() {
      activityDelete({ activityQrcodeId: row.id }).then(() => {
        message.success('删除活码成功')
        tableRef.value?.delFetch()
      })
    }
  })
}

const qrCodeRef = ref()
const qrCodeTitle = ref('')
const visible = ref<boolean>(false)
const currentRow = ref<ActivityCodeListItem>()
const qrCodeType = ref<'zh-CN' | 'en-US'>()
const qrCodeUrl = ref('')
const qrCodeLogoEnum = {
  fbu: require('@/assets/logo_gucang.png'),
  lbu: require('@/assets/logo_yuntu.png')
}
const handleCopy = () => {
  clipboardRef.value = qrCodeUrl.value
  if (unref(copiedRef)) {
    message.success('活动链接复制成功')
  } else {
    message.error('该浏览器不支持自动复制!')
  }
}
const showModal = (lang: 'zh-CN' | 'en-US', row: any) => {
  const langEnum = { 'zh-CN': '中文二维码', 'en-US': '英文二维码' }
  qrCodeType.value = lang
  qrCodeTitle.value = langEnum[lang]
  currentRow.value = row
  qrCodeUrl.value = `${window.WEB_URL}/mobile.html#/activity?qrcodeId=${row.id}&templateId=${row.activityTemplateId}&subdomain=${props.subdomain}&lang=${lang}`
  visible.value = true
}
const handleOk = () => {
  downloadFileByBase64(qrCodeRef.value.imgUrl, `二维码-${currentRow.value?.activityName}-${qrCodeType.value}`)
  visible.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_MoreButton = _resolveComponent("MoreButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dc_layout_main, { "is-breadcrumb": true }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_cos_table, {
              serial: "",
              columns: columns.value,
              search: queryForm,
              "onUpdate:search": _cache[8] || (_cache[8] = ($event: any) => ((queryForm) = $event)),
              onFetch: getList,
              ref_key: "tableRef",
              ref: tableRef,
              tableId: props.subdomain === 'fbu' ? 'DcCosFbuActivityCode' : 'DcCosLbuActivityCode'
            }, {
              search: _withCtx(() => [
                _createVNode(_component_a_form, { model: queryForm }, {
                  default: _withCtx(() => [
                    _createVNode(_component_dc_form_item, {
                      name: "activityName",
                      label: "活动名称"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: queryForm.activityName,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.activityName) = $event)),
                          valueModifiers: { trim: true },
                          maxlength: 100,
                          allowClear: "",
                          placeholder: "请输入"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, {
                      name: "startTime",
                      label: "活动时间"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(CosRangePicker), {
                          startTime: queryForm.startTime,
                          "onUpdate:startTime": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.startTime) = $event)),
                          endTime: queryForm.endTime,
                          "onUpdate:endTime": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.endTime) = $event))
                        }, null, 8, ["startTime", "endTime"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, {
                      name: "partnerId",
                      label: "合作伙伴"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: queryForm.partnerId,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.partnerId) = $event)),
                          fieldNames: { label: 'name', value: 'id' },
                          options: partnerEnum.value,
                          placeholder: "请选择",
                          allowClear: ""
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, {
                      name: "channelList",
                      label: "来源渠道"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ParamCodeCascader, {
                          type: "search",
                          ids: queryForm.channelList,
                          "onUpdate:ids": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.channelList) = $event)),
                          appId: "cos_zbu",
                          options: paramCodeData.value[props.paramCode]
                        }, null, 8, ["ids", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, {
                      name: "follower",
                      label: "活动负责人"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(UserSelect), {
                          value: queryForm.follower,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.follower) = $event)),
                          placeholder: "请选择",
                          allowClear: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, {
                      name: "enableFlag",
                      label: "状态"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          fieldNames: { label: 'name' },
                          value: queryForm.enableFlag,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.enableFlag) = $event)),
                          allowClear: "",
                          placeholder: "请选择",
                          options: statusEnum
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              bodyCell: _withCtx(({ column, record, text }) => [
                (column.dataIndex === 'enableFlag')
                  ? (_openBlock(), _createBlock(_component_dc_status, {
                      key: 0,
                      enums: statusEnum,
                      value: text ? 1 : 0
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'channelId')
                  ? (_openBlock(), _createBlock(ChannelText, {
                      key: 1,
                      appId: "cos_zbu",
                      options: paramCodeData.value[props.paramCode],
                      value: text
                    }, null, 8, ["options", "value"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'action')
                  ? (_openBlock(), _createBlock(_component_MoreButton, { key: 2 }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          onClick: ($event: any) => (triggerAddOrEdit(record.id))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("编辑")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, __props.permission.edit]
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          onClick: ($event: any) => (handleDelete(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("删除")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, __props.permission.delete]
                        ]),
                        (!record.enableFlag)
                          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              type: "link",
                              onClick: ($event: any) => (handleStatus(record))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("启用")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])), [
                              [_directive_permission, __props.permission.enable]
                            ])
                          : _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                              key: 1,
                              type: "link",
                              onClick: ($event: any) => (handleStatus(record))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("停用")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])), [
                              [_directive_permission, __props.permission.disable]
                            ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          onClick: ($event: any) => (handleCardLink(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("关联名片")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, __props.permission.card]
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          onClick: ($event: any) => (showModal('zh-CN', record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("中文二维码")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, __props.permission.qrcode]
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          onClick: ($event: any) => (showModal('en-US', record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("英文二维码")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, __props.permission.qrcode]
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              button: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  type: "primary",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (triggerAddOrEdit()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, __props.permission.add]
                ])
              ]),
              _: 1
            }, 8, ["columns", "search", "tableId"]),
            _createVNode(_component_a_modal, {
              visible: visible.value,
              "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((visible).value = $event)),
              title: qrCodeTitle.value,
              onOk: handleOk
            }, {
              footer: _withCtx(() => [
                _createVNode(_component_a_button, {
                  key: "submit",
                  type: "primary",
                  onClick: handleCopy
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("复制链接")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  key: "submit",
                  type: "primary",
                  onClick: handleOk
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("下载二维码")
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(vueQr, {
                  margin: 0,
                  size: 400,
                  text: qrCodeUrl.value,
                  logoSrc: qrCodeLogoEnum[props.subdomain],
                  logoScale: 0.25,
                  logoMargin: 6,
                  correctLevel: 0,
                  ref_key: "qrCodeRef",
                  ref: qrCodeRef
                }, null, 8, ["text", "logoSrc"])
              ]),
              _: 1
            }, 8, ["visible", "title"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(CardLinkModal, {
      ref_key: "cardLinkModalRef",
      ref: cardLinkModalRef,
      onFetch: _cache[10] || (_cache[10] = ($event: any) => (handleTableFetch()))
    }, null, 512)
  ], 64))
}
}

})